import { CircularIconButton } from '#app/components/Buttons/CircularIconButton.js';
import { Link } from '#app/components/Link/index.js';
import { Menu } from '#app/components/Menu/Menu.js';
import {
  CloseIcon,
  EditAltIcon,
  EditIcon,
  MoreIcon,
  TrashIcon,
} from '@contra/icons/icons';
import { getRoute } from '@contra/routes';
import { css, styled } from 'styled-components';

const MenuButton = styled(CircularIconButton)`
  ${({ theme }) => css`
    background-color: transparent;
    color: ${theme.colorsV2.black};
    height: 32px;
  `}
`;

export const MaybeEditableCardActionsMenuButton = ({
  canEdit,
  editMenuOpen,
  isProfileMagicSuggestion,
  onDismissSuggestion,
  openDeleteModal,
  slug,
  toggleMenu,
  variant,
}: {
  readonly canEdit: boolean;
  readonly editMenuOpen: boolean;
  readonly isProfileMagicSuggestion: boolean;
  readonly onDismissSuggestion: () => void;
  readonly openDeleteModal: () => void;
  readonly slug: string;
  readonly toggleMenu: () => void;
  readonly variant: 'project' | 'service';
}) => {
  const editRoute =
    variant === 'project'
      ? getRoute('/p/@slug/edit', { args: { slug } })
      : getRoute('/s/@slug/edit', { args: { slug } });

  if (!canEdit) {
    return null;
  }

  return (
    <Menu
      isOpen={editMenuOpen}
      placement="top"
      toggleMenu={toggleMenu}
    >
      <Menu.Reference>
        <MenuButton
          aria-label={`Open ${variant} menu`}
          icon={MoreIcon}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            toggleMenu();
          }}
          size="medium"
          variant="V2Link"
        />
      </Menu.Reference>
      <Menu.Panel>
        <Menu.Item
          as={Link}
          icon={isProfileMagicSuggestion ? EditAltIcon : EditIcon}
          to={editRoute}
        >
          {isProfileMagicSuggestion ? 'Add content' : 'Edit'}
        </Menu.Item>

        <Menu.Item
          destructive
          icon={isProfileMagicSuggestion ? CloseIcon : TrashIcon}
          onClick={
            isProfileMagicSuggestion ? onDismissSuggestion : openDeleteModal
          }
        >
          {isProfileMagicSuggestion ? 'Dismiss' : 'Delete'}
        </Menu.Item>
      </Menu.Panel>
    </Menu>
  );
};
